import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LoadingWrapper from 'components/LoadingWrapper';
import intl from 'i18n/intl';
import { fetchFields } from 'slices/field.slice';
import { fetchReservationModes } from 'slices/reservationMode.slice';
import { useAppDispatch } from 'slices/store';
import type { EReservationStatuses } from '@timeedit/types';
import { Alert, Button, DefaultContentLayout } from '@timeedit/ui-components';
import {
  AllocateSettingsLoading,
  getAllocateSettings,
  updateReservationFilterSettings,
} from '../../../slices/appsAllocateSettings';
import {
  PrefReviewLoading,
  PrefReviewSelector,
  getViewLink,
} from '../../../slices/appsPrefReviewSettings';
import { ReservationMode } from './components/ReservationMode';
import { ReservationStatus } from './components/ReservationStatus';

const language = intl.messages as Record<string, string>;

const AllocateReservationFilterPage = () => {
  const dispatch = useAppDispatch();
  const isLoading = useSelector(PrefReviewLoading);
  const isLoadingSettings = useSelector(AllocateSettingsLoading);
  const viewLink = useSelector(PrefReviewSelector);

  const [mode, setMode] = useState<number>(0);
  const [status, setStatus] = useState<EReservationStatuses[]>([]);

  useEffect(() => {
    dispatch(getViewLink());
    dispatch(getAllocateSettings());
    dispatch(fetchFields());
  }, [dispatch]);

  useEffect(() => {
    setMode(viewLink.reservationMode ?? 0);
  }, [viewLink.reservationMode]);

  const _handleSubmit = () => {
    dispatch(
      updateReservationFilterSettings({
        allocateSettings: {
          reservationStatuses: status,
        },
        viewLink: {
          reservationMode: mode,
        },
      })
    );
  };

  return (
    <DefaultContentLayout
      title={language.manage_reservation_filter_page}
      subtitle={language.filterReservations}
      actions={
        <Button type="primary" onClick={_handleSubmit}>
          {language.save_changes}
        </Button>
      }
    >
      <div className="allocate-settings-container">
        <div className="default-content-layout content-box">
          <LoadingWrapper isLoading={isLoading || isLoadingSettings}>
            <div className="limitreservation-wrapper">
              <ReservationMode
                mode={mode}
                setMode={setMode}
                help={
                  <Alert
                    className="row-box help-text"
                    description={language.allocateFilterReservationHelp}
                    type="info"
                    showIcon={false}
                  />
                }
              />
              <br />
              <ReservationStatus status={status} setStatus={setStatus} />
            </div>
          </LoadingWrapper>
        </div>
      </div>
    </DefaultContentLayout>
  );
};

export default AllocateReservationFilterPage;
